var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { signIn, signOut, fetchAuthSession } from "aws-amplify/auth";
import { createContext, useContext, useState } from "react";
const AuthContext = createContext(null);
export const useAuthData = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuthData must be used within an AuthProvider");
    }
    return context;
};
export const AuthProvider = ({ children }) => {
    const [errorName, setErrorName] = useState("");
    const [loading, setLoading] = useState(false);
    const handleError = (error) => __awaiter(void 0, void 0, void 0, function* () {
        console.error("error", error);
        switch (error.name) {
            case "NotAuthorizedException":
                setErrorName("Wrong password. Try again or email support@teammofo.com.");
                break;
            case "UserNotFoundException":
                setErrorName("Could not find your Modern Football Account.");
                break;
            case "UserAlreadyAuthenticatedException":
                // Clear cookies related to auth
                document.cookie =
                    "user=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Lax";
                // Attempt to sign out first before redirecting
                try {
                    yield signOut();
                }
                catch (signOutError) {
                    console.error("Error signing out:", signOutError);
                }
                window.location.reload();
                break;
            default:
                setErrorName("Login failed. Please try again.");
        }
    });
    const login = (username, password) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setLoading(true);
        try {
            yield signIn({ username, password });
            const session = yield fetchAuthSession();
            const jwtToken = (_a = session.tokens) === null || _a === void 0 ? void 0 : _a.idToken;
            const days = 1;
            const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
            if (jwtToken) {
                // IMPORTANT!
                // this cookie is passed to the packages/gateway/index.js (gateway),
                // and is used to then fetch user's active subscriptions
                document.cookie = `user=${jwtToken}; path=/; expires=${expires}; Secure; SameSite=Lax`;
                window.location.reload();
            }
        }
        catch (error) {
            handleError(error);
        }
        finally {
            setLoading(false);
        }
    });
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield signOut();
            window.location.reload();
        }
        catch (error) {
            console.error("Logout failed:", error);
            throw error;
        }
    });
    return (_jsx(AuthContext.Provider, Object.assign({ value: {
            logout,
            login,
            errorName,
            loading,
        } }, { children: children })));
};
export const useAuth = () => useContext(AuthContext);
